const FETCH_RECORD_REQUEST = 'SCREENS/TBTSIGNINGVIEW/FETCH_RECORD_REQUEST'
const FETCH_RECORD_SUCCESS = 'SCREENS/TBTSIGNINGVIEW/FETCH_RECORD_SUCCESS'
const FETCH_RECORD_FAILURE = 'SCREENS/TBTSIGNINGVIEW/FETCH_RECORD_FAILURE'
const FETCH_DOC_REQUEST = 'SCREENS/TBTSIGNINGVIEW/FETCH_DOC_REQUEST'
const FETCH_DOC_SUCCESS = 'SCREENS/TBTSIGNINGVIEW/FETCH_DOC_SUCCESS'
const FETCH_DOC_FAILURE = 'SCREENS/TBTSIGNINGVIEW/FETCH_DOC_FAILURE'
const SIGN_REQUEST = 'SCREENS/TBTSIGNINGVIEW/SIGN_REQUEST'
const SIGN_SUCCESS = 'SCREENS/TBTSIGNINGVIEW/SIGN_SUCCESS'
const SIGN_FAILURE = 'SCREENS/TBTSIGNINGVIEW/SIGN_FAILURE'
const RESET = 'SCREENS/TBTSIGNINGVIEW/RESET'

export {
  FETCH_RECORD_REQUEST,
  FETCH_RECORD_SUCCESS,
  FETCH_RECORD_FAILURE,
  FETCH_DOC_REQUEST,
  FETCH_DOC_SUCCESS,
  FETCH_DOC_FAILURE,
  SIGN_REQUEST,
  SIGN_SUCCESS,
  SIGN_FAILURE,
  RESET,
}

const defaultState = {
  record: null,
  loading: false,
  error: null,
  documentUrl: null,
  documentType: null,
  documentLoading: false,
  signing: false,
  signed: false,
}

const tbtSigningView = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_RECORD_REQUEST:
      return { ...state, loading: true, error: null }
    case FETCH_RECORD_SUCCESS:
      return { ...state, loading: false, record: action.payload }
    case FETCH_RECORD_FAILURE:
      return { ...state, loading: false, error: action.payload }
    case FETCH_DOC_REQUEST:
      return { ...state, documentLoading: true }
    case FETCH_DOC_SUCCESS:
      return { ...state, documentLoading: false, documentUrl: action.payload.url, documentType: action.payload.type }
    case FETCH_DOC_FAILURE:
      return { ...state, documentLoading: false }
    case SIGN_REQUEST:
      return { ...state, signing: true }
    case SIGN_SUCCESS:
      return { ...state, signing: false, signed: true, record: { ...state.record, signed: true, signed_at: action.payload.signed_at } }
    case SIGN_FAILURE:
      return { ...state, signing: false }
    case RESET:
      return defaultState
    default:
      return state
  }
}

export default tbtSigningView
